export default "__VITE_ASSET__BPZGDv96__"